<script>
    import Footer from '../landing_page/footer.svelte';
    import NavbarMenu from '../navbar/navbar_menu.svelte';
    import Navbar from '../navbar/navbar.svelte';
    import ThankYou from '../thankyou_popup/thanku.svelte';
    import {showThankUPopUp} from './store.js';
    const {title} = rpcjs.props;
    title.set('Contact Us');
    const contact = [
        {
            image: '/images/contact_us/phone.svg',
            detail: '+1 (650) 427-9813',
            link: 'tel:+1 (650) 427-9813',
        },
        {
            image: '/images/contact_us/mail.svg',
            detail: ' info@draperuniversity.com',
            link: ' mailto: info@draperuniversity.com',
        },
        {
            image: '/images/contact_us/location.svg',
            detail: '44 E. 3rd Avenue, San Mateo CA 94401.',
            link: '',
        },
    ];
    const formData = {
        name: '',
        email: '',
        msg: '',
    };
    // <!-- Google Tag Manager -->
    (function(w, d, s, l, i) {
        w[l]=w[l]||[]; w[l].push({'gtm.start':
        new Date().getTime(), 'event': 'gtm.js'}); const f=d.getElementsByTagName(s)[0];
        const j=d.createElement(s); const dl=l!='dataLayer'?'&l='+l:''; j.async=true; j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-N8TD4HQ');
    // <!-- End Google Tag Manager -->
    /**
     *
     *
  */
    function displayPopUp() {
        showThankUPopUp.update((n) => n + 1);
    }
    /**
     *
     * @param {string}object
     */
    async function SaveData() {
        const functionUrl = 'https://us-central1-draper-university.cloudfunctions.net/sendEmail';
        await fetch(functionUrl, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                data: [formData.email, formData.name, formData.msg, 'Contact Us'],
            }),
        }).then(function(res) {
            if (res.status === 200) {
                displayPopUp();
            } else {
                alert('ERROR!', res);
            }
        });
    }
    $: console.log('showThankUPopUp', $showThankUPopUp);
</script>

<section>
    <div class="desktop">
        <Navbar />
    </div>
    <div class="mobile">
        <NavbarMenu backgroundColor="transparent" stroke="black" />
    </div>
    <ThankYou/>
    <div class="desktop">
        <div class="heading">
            <p>How Can We Help?</p>
        </div>
        <div class="contact-us">
            <div class="contact-info">
                <div class="contact-head">
                    <p>Contact Us.</p>
                </div>
                <div class="pre">
                    <p >
                        You can call or send us a WhatsApp message and we’ll get
                        back to you. If we do not pick up please leave a message
                        and we will call back as soon as we are available.
                    </p>
                </div>

                <div style="margin-top:18vw; margin-left:12.897vw; ">
                    {#each contact as data}
                        <div style="display: flex; cursor:pointer;" on:click={() =>
                            (location.href = data.link)}>
                            <div class="icon">
                                <img src={data.image} alt="" width="100%" />
                            </div>
                            <div class="detail" >
                                <p>{data.detail}</p>
                            </div>
                        </div>
                    {/each}
                </div>
            </div>
            <div class="contact-form">
                <div style="margin-left: 3.968vw;">
                    <form on:submit|preventDefault={SaveData}>
                        <div
                            style="font-size: 1.190vw; font-weight:700;margin-top:1.918vw;margin-bottom:0.397vw;"
                        >
                            <p>Your Name</p>
                        </div>
                        <div>
                            <input
                                required
                                class="name"
                                type="text"
                                placeholder="Olive Yew"
                                bind:value={formData.name}
                            />
                        </div>
                        <div
                            style="font-size: 1.190vw; font-weight:700;margin-top:1.587vw;margin-bottom:0.661vw;"
                        >
                            <p>Mail</p>
                        </div>
                        <div>
                            <input
                                required
                                class="mail"
                                type="email"
                                placeholder="example@domain.com"
                                bind:value={formData.email}
                            />
                        </div>
                        <div
                            style="font-size: 1.190vw; font-weight:700;margin-top:1.521vw;margin-bottom:0.794vw;"
                        >
                            <p>Message</p>
                        </div>
                        <div>
                            <textarea
                                required
                                class="msg"
                                type="text"
                                placeholder="Message"
                                bind:value={formData.msg}
                            />
                        </div>
                        <div
                            style="    margin-top: 1.984vw;margin-bottom: 1.786vw;
                                margin-left: 8.5vw;"
                        >
                            <button class="btn">Send Message</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="mobile">
        <div class="heading-mbl">
            <p>How Can We Help?</p>
        </div>
        <div class="contact-us-mbl">
            <div class="contact-head-mbl">
                <p>Contact Us.</p>
            </div>
            <div class="pre-mbl">
                <p>
                    You can call or send us a WhatsApp message and we’ll get
                    back to you. If we do not pick up please leave a message and
                    we will call back as soon as we are available.
                </p>
            </div>
            <div style="padding-top: 56vw; margin-left:12.897vw;">
                {#each contact as data}
                    <div style="display: flex;align-items: baseline;margin-top: 4.89vw;" on:click={() =>
                        (location.href = data.link)}>
                        <div class="icon-mbl">
                            <img src={data.image} alt="" width="100%" />
                        </div>
                        <div class="detail-mbl">
                            <p>{data.detail}</p>
                        </div>
                    </div>
                {/each}
            </div>
            <div class="contact-form-mbl">
                <div style="margin-left: 9.568vw;">
                    <form on:submit|preventDefault={SaveData}>
                        <div
                            style="font-size: 2.869vw; font-weight:700;padding-top: 5.2vw;"
                        >
                            <p>Your Name</p>
                        </div>
                        <div style="    margin-top: 2.418vw;">
                            <input
                                required
                                class="name-mbl"
                                type="text"
                                placeholder="Olive Yew"
                                bind:value={formData.name}
                            />
                        </div>
                        <div
                            style="font-size: 2.869vw; font-weight:700;padding-top: 5.2vw;"
                        >
                            <p>Mail</p>
                        </div>
                        <div style="    margin-top: 2.418vw;">
                            <input
                                required
                                class="mail-mbl"
                                type="email"
                                placeholder="example@domain.com"
                                bind:value={formData.email}
                            />
                        </div>
                        <div
                            style="font-size: 2.869vw; font-weight:700;padding-top: 5.2vw;"
                        >
                            <p>Message</p>
                        </div>
                        <div style="    margin-top: 2.418vw;">
                            <textarea
                                required
                                class="msg-mbl"
                                type="text"
                                placeholder="Message"
                                bind:value={formData.msg}
                            />
                        </div>
                        <div
                            style="margin-top:2.5vw;
                                margin-left: 22.5vw;padding-bottom: 3.5vw;"
                        >
                            <button class="btn-mbl">Send Message</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    <Footer />
</section>

<style>
    p{
        margin: 0;
        padding: 0;
    }
    .heading {
        font-size: 3.307vw;
        font-weight: 600;
        text-align: center;
        margin-top: 14.815vw;
        background: linear-gradient(1.05deg, #00204b 50.19%, #00429b 99.35%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .contact-us {
        background: linear-gradient(1.05deg, rgb(0, 32, 75) 25.19%, rgb(0, 66, 155) 99.35%);
        border-radius: 2vw 2vw 0vw 0vw;
        height: 49.537vw;
        margin-top: 7.870vw;
        position: relative;
        display: flex;
        margin-bottom: -0.2vw;
    }
    .contact-us-mbl {
        background: linear-gradient(1.05deg, #00204b 50.19%, #00429b 99.35%);
        border-radius: 9vw 9vw 0vw 0vw;
        height: fit-content;
        margin-top: 11.772vw;
        position: relative;
    }
    .contact-head {
        font-size: 1.984vw;
        font-weight: 400;
        color: white;
        position: absolute;
        left: 9.458vw;
        top: 7.937vw;
    }
    .contact-head-mbl {
        font-size: 5.556vw;
        font-weight: 400;
        color: white;
        position: absolute;
        left: 8.611vw;
        top: 18.5vw;
    }
    .pre {
        width: 29.696vw;
        font-size: 1.058vw;
        line-height: 1.28vw;
        position: absolute;
        left: 9.458vw;
        top:11.971vw;
        line-height: 1.280vw;
        color: white;
    }
    .pre-mbl {
        width: 73.889vw;
        font-size: 3.056vw;
        line-height: 3.697vw;
        position: absolute;
        left: 8.611vw;
        top: 30.971vw;
        color: white;
    }
    .contact-form {
        width: 37.302vw;
        background: #ffffff;
        border-radius: 1.984vw;
        position: absolute;
        top: 3.902vw;
        left: 54.497vw;
    }
    .contact-form-mbl {
        width: 89.914vw;
        height: fit-content;
        background: #ffffff;
        border-radius: 4.783vw;
        margin: auto;
        margin-top: 12vw;
    }
    .name {
        width: 18.915vw;
        height: 3.638vw;
        border-radius: 0.661vw;
        border: 0.132vw solid #ababab;
        padding-left: 1vw;
        font-size: 1.058vw;
    }
    .mail {
        width: 21.098vw;
        height: 3.638vw;
        border-radius: 0.661vw;
        border: 0.132vw solid #ababab;
        padding-left: 1vw;
        font-size: 1.058vw;
    }
    .msg {
        width: 29.365vw;
        height: 16.071vw;
        border-radius: 0.661vw;
        border: 0.132vw solid #ababab;
        padding-left: 1vw;
        padding-top: 1vw;
        font-size: 1.058vw;
    }
    .name-mbl {
        width: 45.594vw;
        height: 10.361vw;
        border-radius: 1.95vw;
        border: 0.132vw solid #ababab;
        padding-left: 3vw;
        font-size: 2.55vw;
    }
    .mail-mbl {
        width: 50.856vw;
        height: 10.361vw;
        border-radius: 1.95vw;
        border: 0.132vw solid #ababab;
        padding-left: 3vw;
        font-size: 2.55vw;
    }
    .msg-mbl {
        width: 70.644vw;
        height: 38.739vw;
        border-radius: 1.95vw;
        border: 0.132vw solid #ababab;
        padding-left: 3vw;
        padding-top: 2vw;
        font-size: 2.55vw;
    }
    .btn {
        background-color: #3c74c0;
    color: white;
    font-size: 1.19vw;
    font-weight: 500;
    border-radius: 1.984vw;
    border: none;
    width: 14.947vw;
    height: 3.638vw;
    }
    .btn-mbl {
        background-color: #3c74c0;
        color: white;
        font-size: 2.55vw;
        font-weight: 500;
        border-radius: 3.984vw;
        border: none;
        padding: 1.8vw 5vw;
    }
    .icon {
        margin-top: 2.175vw;
        width: 1.653vw;
    }
    .detail {
        margin-top: 2.175vw;
        margin-left: 2vw;
        color: white;
        font-size: 1.058vw;
    }
    .icon-mbl {
        margin-top: 3.307vw;
        width: 5.556vw;
    }
    .detail-mbl {
        margin-top: 3.307vw;
        margin-left: 4vw;
        color: white;
        font-size: 3.889vw;
    }
    .desktop {
        display: block;
    }
    .mobile {
        display: none;
    }
    .heading-mbl {
        width: 66.944vw;
        font-size: 8.333vw;
        font-weight: 600;
        margin: auto;
        text-align: center;
        background: linear-gradient(1.05deg, #00204b 20.19%, #00429b 29.35%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        padding-top: 48.056vw;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
    }
</style>
